import React from "react";
import ReactDOM from 'react-dom';
import 'styles/common.less';
import "./index.less";
import MattersImg from "imgs/matters.svg";
import QrcodeImg from "imgs/qrcode.svg";
import WechatImg from "imgs/wechat.svg";

import Layout from "../common/layout";
import Square from "../common/square";

function App() {
    return (
        <Layout headerImg={MattersImg}>
            <div className="matters-wrap">
                <div className="matters-title">简历投递最多只限5家单位，每家单位最多投递1个岗位</div>
                <div className="matters-title">简历投递后，当简历状态显示“待处理”时，可以更换应聘公司或修改简历信息；其它状态下则无法变更或修改，一定要三思而后投哦！</div>
                <div className="matters-content">
                    <div className="matters-left">
                        <div className="matters-btn">移动端投递</div>
                        <div className="matters-left-tips">
                            <img src={WechatImg} />
                            <div className="matters-left-tips-text">关注[东风汽车招聘]公众号-人才招聘-招聘岗位-校园招聘或扫描下方二维码即可快速跳转至公众号哦！</div>
                        </div>
                        <Square width={148}>
                            <img className="matters-qrcode" src={QrcodeImg} />
                        </Square>
                    </div>
                    <div className="matters-right">
                        <div className="matters-btn btn-big">PC端投递网址</div>
                        <div className="matters-right-title">搜索下方网址，进入校园招聘频道，登录或注册账号，</div>
                        <div className="matters-right-title">查找心仪的公司及岗位进行简历投递</div>
                        <div className="matters-right-address">dfmc.hotjob.cn</div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

ReactDOM.render(
    <App />, document.getElementById('root')
);
